import Opener, { OpenerSlotProps } from '@Ravnur-Inc/core/components/opener/opener';
import { Inject, Watch } from '@Ravnur-Inc/decorators';
import $t from '@Ravnur-Inc/l10n/$t';
import { Vue } from '@Ravnur-Inc/vue-class-component';

import './user-menu.scss';
import { ApplicationNames } from '@Ravnur-Inc/shared/types/Application';

const CN = 'user-menu';

export default class ApplicationsMenu extends Vue {
  declare $refs: {
    opener: Opener;
  };

  @Inject('current-user') private user: User$Details;
  @Inject('application-name') private applicationName: ApplicationNames;
  @Inject('is-admin') private isAdmin: boolean;
  @Inject('logout') private emitLogoutEvent: () => void;
  @Inject('to-my-account') private toMyAccount: (() => void) | undefined;
  @Inject('to-admin-panel') private toAdminPanel: () => void;

  private get slots() {
    return {
      summary: this.renderDashboardTitle,
      details: this.renderDashboardOptions,
    };
  }

  private get noMenuLinks() {
    return !this.toMyAccount && !this.isAdmin;
  }

  @Watch('$route.query')
  @Watch('$route.name')
  protected handleRouteChanged() {
    this.$refs.opener.hide();
  }

  render() {
    return <Opener ref="opener" class={CN} v-slots={this.slots} />;
  }

  private renderDashboardTitle({ toggle, visible }: OpenerSlotProps) {
    const { user } = this;

    return (
      <div
        class={[`${CN}__dropdown`, visible ? 'active' : '', this.noMenuLinks ? 'no-links' : '']}
        tabindex="0"
        onClick={toggle}
      >
        {this.toMyAccount ? (
          <div class={`${CN}__dropdown-title`}>{$t('header', 'user-menu__my-account')}</div>
        ) : (
          this.isAdmin && (
            <div class={`${CN}__dropdown-title`}>{$t('header', 'user-menu__admin-portal')}</div>
          )
        )}
        <avatar class={`${CN}__avatar`} title={user.displayName} user={user} />
      </div>
    );
  }

  private renderDashboardOptions() {
    return (
      <paper class={`${CN}__dropdown-menu`}>
        {this.applicationName !== ApplicationNames.MY_ACCOUNT && this.toMyAccount && (
          <div class={`${CN}__dropdown-menu-item`} onClick={this.toMyAccount}>
            <l10n group="header" tkey="user-menu__my-account" />
          </div>
        )}
        {this.isAdmin && (
          <div class={`${CN}__dropdown-menu-item`} onClick={this.toAdminPanel}>
            <l10n group="header" tkey="user-menu__admin-portal" />
          </div>
        )}
        <div class={`${CN}__dropdown-menu-item`} onClick={this.logout}>
          <l10n group="header" tkey="user-menu__sign-out" />
        </div>
      </paper>
    );
  }

  private logout(e: Event) {
    e.preventDefault();
    this.emitLogoutEvent();
  }
}
